import { render, staticRenderFns } from "./NuevoSignoVital.vue?vue&type=template&id=3b3e6b68&scoped=true"
import script from "./NuevoSignoVital.vue?vue&type=script&lang=js"
export * from "./NuevoSignoVital.vue?vue&type=script&lang=js"
import style0 from "./NuevoSignoVital.vue?vue&type=style&index=0&id=3b3e6b68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3e6b68",
  null
  
)

export default component.exports